import { useMemo } from 'react';
import clsx from 'clsx';
import { RadioInputOrientationTypeEnum } from './models';
import styles from './styles.module.css';
import { PaletteUtils } from '@shared/utils';

interface IProps {
  options: {
    text: string;
    value: string;
  }[];
  selected?: string;
  onChange: (val: string) => void;
  orientation: RadioInputOrientationTypeEnum;
  readonly?: boolean;
}

export const RadioInput = (props: IProps) => {
  const isVertical = useMemo(() => {
    return props.orientation == RadioInputOrientationTypeEnum.Vertical;
  }, [props.orientation]);

  return (
    <fieldset className={clsx('w-full flex border-none p-0', isVertical ? 'flex-col' : 'flex-row')}>
      {props.options.map((item, key) => (
        <div
          key={key}
          onClick={() => !props.readonly && props.onChange(item.value)}
          className={clsx(
            'items-center flex bg-white rounded-tl-md rounded-bl-md dark:bg-soft-black pr-2',
            isVertical ? 'border-[1px] dark:border-gray-white border-black mb-1 rounded px-3 py-2' : 'mr-3',
            props.readonly && 'border-gray-400',
          )}
        >
          <input
            type='radio'
            className={clsx(styles.radio, PaletteUtils.isVcfcPalette && styles.vcfc)}
            readOnly={props.readonly}
            value={item.value}
            onChange={() => {}}
            checked={item.value === props.selected}
          />
          <label className={clsx(props.readonly && 'text-gray-400')}>{item.text}</label>
        </div>
      ))}
    </fieldset>
  );
};
